/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { ListItem } from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';

import DateTime from '../../../../components/DateTime';
import Duration from '../../../../components/Duration';

import type { TutorJobBooked_job } from './__generated__/TutorJobBooked_job.graphql';

type Props = {
  job: TutorJobBooked_job,
};

const TutorJobBooked = ({ job }: Props) => {
  const { acceptedJobOffer } = job;
  const { sessions, jobRequest } = acceptedJobOffer;
  const { grade, subject } = jobRequest;
  const {
    firstname,
    lastname,
    profilePictureThumbnailUri,
  } = jobRequest.student;

  return (
    <ListItem
      leftAvatar={<Avatar src={profilePictureThumbnailUri} />}
      rightIcon={<ActionInfo />}
      primaryText={
        <div>
          {sessions.map(({ timeSlot }) => (
            <span key={timeSlot.id}>
              <Duration {...timeSlot.duration} />
              {` of ${subject.name} (${grade.name}) `}
              <DateTime value={timeSlot.startDate} />
            </span>
          ))}
        </div>
      }
      // $FlowFixMe
      secondaryText={`${firstname.toString()} ${lastname.toString()}`}
    />
  );
};

export default createFragmentContainer(TutorJobBooked, {
  job: graphql`
    fragment TutorJobBooked_job on Job {
      id
      acceptedJobOffer {
        sessions {
          timeSlot {
            id
            startDate
            duration {
              minutes
              hours
            }
          }
        }
        jobRequest {
          student {
            profilePictureThumbnailUri
            firstname
            lastname
          }
          grade {
            name
          }
          subject {
            name
          }
        }
        totalRateStudent
        totalRateTutor
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/job/TutorJobBooked.js